import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsService } from '@core/services/credentials.service';
import { Observable } from 'rxjs';
import { ContactInfo } from './contact.types';

const routes = {
  getContactsInfo: () => `/org/sgs/configuration/contact-info`,
};

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(
    private httpClient: HttpClient,
    private credentialsService: CredentialsService,
  ) {}

  getContactsInfo(): Observable<ContactInfo> {
    return this.httpClient.get<ContactInfo>(routes.getContactsInfo(), {
      // headers: new HttpHeaders({
      //   Authorization: `Bearer ${this.credentialsService.credentials.token}`,
      // }),
    });
  }
}
